<template>
    <div class="navigation flex --font">
        <h2 :class="{'active' : $route.name === 'profileSettings'}" 
            class="pointer mr-2" 
            @click="$router.push({ name : 'profileSettings' })">
            Profile settings
        </h2>
        <h2 
            :class="{'active' : $route.name !== 'profileSettings'}"
            class="pointer ml-2" 
            @click="navigateToPasswordRoute"> {{ $store.state.mainStore.profileNavigationText }} </h2>
    </div>
</template>

<script>
// import {eventBus} from "../../../../main"
export default {
    name : "profileNavigation",

    methods : {
        navigateToPasswordRoute() {
            if(this.$store.state.mainStore.profileNavigationText === 'Change Password')
                this.$router.push({ name : 'changePassword' })
            else 
                this.$router.push({ name : 'createPassword' })
        }
    }
}
</script>

<style lang="scss" scoped>

.navigation {
    padding: 50px 0;
}

.pointer {
    color:#CACACA;

    &.active {
        color: var(--secondary-font);
    }
}

</style>